import nativeBridge from "../nativeBridge";
import {baseUrlForWebsite} from "../../client/PlaygroundSettings";

export type RootWebsitePathType = `/${string}`;

class Navigation {
  public goToExternal(url: string) {
    if (nativeBridge.isRunningInNativeContainer) {
      nativeBridge.tellNativeToOpenUrlInBrowser(url);
    } else {
      window.open(url, "_blank");
    }
  }

  public goToExternalPlaygroundSitePath(path: RootWebsitePathType) {
    this.goToExternal(`${baseUrlForWebsite}${path}`);
  }

  public goToExternalPlaygroundSongStoreLesson(lessonId: number | string) {
    this.goToExternalPlaygroundSitePath(`/store/view-song/${lessonId}` as RootWebsitePathType);
  }

  public goToExternalPlaygroundStoreMembershipPlans() {
    this.goToExternalPlaygroundSitePath(`/register?asMembership=lifetime`);
  }
}

/**
 * Usage - These all route to the same location.
 * navigate('/songs/browse');
 * navigate('/songs/browse', true);
 *
 * Navigating with "replace" will replace the current history entry with the new one.
 *
 * The signature of this method is intentionally kept different from that of useNavigate() in react-router-dom,
 * so it's clear which one is being used, without looking at the import.
 *
 * @deprecated Use react-router-dom's useNavigate() instead.
 */
export const navigate = (url: string, replace: boolean = false) => {
  const fragment = url.startsWith("#") ? url.slice(1) : url;
  const newHref = `${window.location.href.split("#")[0]}#${fragment}`;

  if (replace) {
    // https://developer.mozilla.org/en-US/docs/Web/API/History/replaceState
    // Don't use, since it doesn't trigger a refresh
    // history.replaceState(null, '', newHref);

    // https://developer.mozilla.org/en-US/docs/Web/API/Location/replace
    window.location.replace(newHref);
    return;
  }

  // Prefix "#". WKWebView treats `location.hash = "/bootCamp/35"` as a load of
  // that path. Nothing is served there, so the web view goes blank.
  window.location.hash = `#${fragment}`;
};

export const navigation = new Navigation();
export default navigation;
